var menu =
    [
        {
            title: 'Contents',
            route: 'contents', 
            icon: 'ImageIcon',
        },
        {
            title: 'Blogs',
            route: 'blogs', 
            icon: 'HeartIcon',
        },
        {
            title: 'Settings',
            route: 'settings', 
            icon: 'SettingsIcon',
        },
    ]

export default menu;

